import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'lokos-button-toggle',
    templateUrl: './button-toggle.component.html',
    styleUrl: './button-toggle.component.scss',
    standalone: false
})
export class ButtonToggleComponent implements OnChanges {
    @Input({ required: false }) control!: FormControl;
    @Input({ required: false }) displayName!: string;
    @Input({ required: false }) getName!: string;
    @Input({ required: false }) options!: any[];
    @Input({ required: false }) value!: any;
    @Input({ required: false }) className = '';

    ngOnChanges (changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }
}
